// Инструкция к применению:
// Смотрим на сообщение, которое приходит с бэка и нужно локализировать
// 'User "Federiko" cannot upgrade to "god_story" plan' - переменные оборачиваем и добавляем ключ локали, получается
// 'User {userName} cannot upgrade to {plan} plan': 'BACKEND_MESSAGES.CANNOT_UPGRADE_PLAN'

export const MESSAGE_TO_KEY: Record<string, string> = {
  'Forbidden: Invalid password': 'BACKEND_MESSAGES.INVALID_PASSWORD',
  'Bad Request: Slug {slug} is already taken by another user': 'BACKEND_MESSAGES.SLUG_ALREADY_TAKEN',
  'Forbidden: You do not have enough tokens to generate this image': 'BACKEND_MESSAGES.NOT_ENOUGH_TOKENS',
  'Bad Request: boostyEmail must be an email': 'COMMON.ERROR.INVALID_EMAIL',
  'Forbidden: Selected model is not available for this character. Free models are blocked for this character. Total context ({number} tokens) exceeds limit (5000). Please use a paid model.':
    'BACKEND_MESSAGES.TOKENS_EXCEEDED',
  'Selected model is not available for this character. Free models are blocked for this character. Total context ({number} tokens) exceeds limit (5000). Please use a paid model.':
    'BACKEND_MESSAGES.TOKENS_EXCEEDED',
};

/**
 * Регулярное выражение для поиска переменных в шаблоне вида {variableName}
 * Пример: в строке "User {name} tried {action}" найдет ['name', 'action']
 */
export const TEMPLATE_VARIABLE_PATTERN = /\{([^}]+)\}/g;

/**
 * Регулярное выражение для замены экранированных переменных \{variableName\} на захватывающие группы (.+?)
 * Используется после escapeRegex для создания паттерна сопоставления
 */
export const ESCAPED_VARIABLE_PATTERN = /\\{[^}]+\\}/g;

/**
 * Регулярное выражение для экранирования специальных символов regex
 * Экранирует символы: . * + ? ^ $ { } ( ) | [ ] \
 */
export const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;

/**
 * Захватывающая группа для regex, которая соответствует любому тексту (нежадная)
 * Используется для замены переменных в шаблоне на паттерн, который захватит их значение
 * Пример: "User {name}" -> "User (.+?)" -> захватит любое имя пользователя
 */
export const CAPTURING_GROUP_PATTERN = '(.+?)';

/**
 * Паттерн замены для экранирования специальных символов regex
 * $& вставляет найденное совпадение с обратным слешем перед ним
 * Пример: "test." -> "test\\."
 */
export const ESCAPE_REPLACEMENT = '\\$&';
